import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { useToast } from "@src/appV2/lib";
import { logError } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { useJoinClipboardGuidesChannel } from "../api/useJoinClipboardGuidesChannel";

interface ChatWithClipboardGuidesButtonProps {
  workplaceId: string;
  workplaceName: string;
  shiftId: string;
}

export function ChatWithClipboardGuidesButton(
  props: ChatWithClipboardGuidesButtonProps
): JSX.Element {
  const { workplaceId, workplaceName, shiftId } = props;
  const worker = useDefinedWorker();
  const history = useHistory();
  const { showErrorToast } = useToast();

  const { mutateAsync: joinChannel, isLoading: isJoiningChannel } = useJoinClipboardGuidesChannel({
    workplaceId,
  });

  return (
    <Button
      invert
      startIconType="text-bubble"
      size="small"
      variant="contained"
      disabled={isJoiningChannel}
      sx={(theme) => ({ boxShadow: theme.shadows[2] })}
      onClick={async () => {
        try {
          const response = await joinChannel({
            workerId: worker.userId,
            shiftId,
          });
          const { channelUrl } = response.data.attributes;

          history.push({
            pathname: generatePath(DeprecatedGlobalAppV1Paths.CLIPBOARD_GUIDES_CHAT, {
              workplaceId,
            }),
            state: {
              channelUrl,
              workplaceName,
            },
          });
        } catch (error) {
          logError("Failed to join clipboard guides channel", { error });
          showErrorToast("Something went wrong. Please try again.");
        }
      }}
    >
      Ask a question
    </Button>
  );
}
